import { useState, useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import Breadcrumb from '../../components/Breadcrumbs.component';
import Pagination from '../../components/Pagination.component';
import {
  deleteTasksSolutionSheetDetails,
  processCards,
  processAllCards,
  exportSolutionSheetsApi,
  removeCards,
  removeCardsByFiltres,
} from '../../services/images/images.service';
import { useStyles } from '../styles';
import Layout from '../../components/Layout/Layout.component';
import { useHistory } from 'react-router-dom';
import {
  ITasksSolutionSheet,
  CardsSortBy,
  TasksSolutionSheetStatusDetail,
  TasksSolutionSheetStatusId,
  DeleteTasksSolutionSheetEnumResult,
  ITasksSolutionSheetDto,
} from '../../models/solutionCard.types';
import { Paths } from '../../utils/routerUrls';
import { CardsTableItem } from './Cards.types';
import { ActionMenuItem } from '../../components/ActionsMenu/ActionsMenu.types';
import ActionsMenu from '../../components/ActionsMenu/ActionsMenu.component';
import _ from 'lodash';
import { ItemsFilter } from '../../components/SelectableTable/filters/ItemsFilter.component';
import Pipe from '../../assets/icons/pipe.svg';
import { SelectableTable } from '../../components/SelectableTable/SelectableTable.component';
import { DateFilter } from '../../components/SelectableTable/filters/DateFilter.component';
import { formatDate } from '../Assessment/Helpers/FormatDate.component';
import { useLayoutContext } from '../../Context/Layout.context';
import { useTranslation } from 'react-i18next';
import { convertToFilterItems } from '../SampleAssessmentRepo/Helpers/AccountTypeRendering';
import CardStatusIcon from '@material-ui/icons/FiberManualRecord';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import { Prompt } from '../../components/Prompt/Prompt.component';
import DotWithLabel from '../../components/DotWithLabel.component';
import { getCommitteeLabel } from '../../models/committees.types';
import OutlinedButton from '../../components/buttons/OutlinedButton.component';
import { SelectedRecordCountDisplay } from '../../components/SelectableTable/SelectedRecordCountDisplay/SelectedRecordCountDisplay.component';
import { exportFile } from '../../utils/servicesHelper';
import { useCardsTableData } from './useCardsTableData';
import { useCardsTableColumns } from './useCardsTableColumns';
import { SolutionCardModal } from '../SolutionCard/SolutionCardModal.component';

const Cards: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const abortController = useRef<AbortController>();

  const { openAlert, showLoader, isSidebarMinimized } = useLayoutContext();
  const { t } = useTranslation();

  const {
    filter,
    pageInfo,
    cards,
    itemsSelection,
    setItemsSelection,
    forceDeselectAllItems,
    setForceDeselectAllItems,
    filterState,
    examCommitteeFilter,
    tasksSolutionSheetStatusId,
    sortByColumnId,
    setSortByColumnId,
    isDescending,
    setIsDescending,
    handleFilterChange,
    getCards,
    uncheckAllFilters,
    uncheckFilterItem,
    getPages,
    getFilterValues,
  } = useCardsTableData();

  const [cardsData, setCardsData] = useState<CardsTableItem[]>([]);

  const [activeCardId, setActiveCardId] = useState<string>('');
  const [canCardBeRemoved, setCanCardBeRemoved] = useState<boolean>(false);
  const [processingPromptOpen, setProcessingPromptOpen] = useState<boolean>(false);
  const [processingSuccessPromptOpen, setProcessingSuccessPromptOpen] = useState<{
    value: boolean;
    cardsToProcess: number;
  }>({ value: false, cardsToProcess: 0 });
  const [processingErrorPromptOpen, setProcessingErrorPromptOpen] = useState<boolean>(false);

  const [removingCardsPromptOpen, setRemovingCardsPromptOpen] = useState<boolean>(false);
  const [solutionCardModalOpen, setSolutionCardModalOpen] = useState<boolean>(false);
  const [selectedCardId, setSelectedCardId] = useState<string>('');

  const adminTasksSolutionSheetReadusePermission = usePermission(UserPermission.AdminTasksSolutionSheetRead);
  const adminOkeTaskSolutionSheetReadusePermission = usePermission(UserPermission.AdminOkeTaskSolutionSheetRead);
  const adminOkeTaskSolutionSheetProcessingusePermission = usePermission(
    UserPermission.AdminOkeTaskSolutionSheetProcessing,
  );
  const adminTasksSolutionSheetProcessing = usePermission(UserPermission.AdminTasksSolutionSheetProcessing);

  const hasAdminUserRoleSolutionSheetReadPermission =
    adminTasksSolutionSheetReadusePermission || adminOkeTaskSolutionSheetReadusePermission;

  const hasAdminProcessingOrAdminOkeProcessingPermission =
    adminOkeTaskSolutionSheetProcessingusePermission || adminTasksSolutionSheetProcessing;

  const openRemovingModal = (data: ITasksSolutionSheet) => {
    setActiveCardId(data.id);
    setCanCardBeRemoved(true);
  };

  const deleteCard = () => {
    deleteTasksSolutionSheetDetails(activeCardId).then(
      (result: DeleteTasksSolutionSheetEnumResult) => {
        switch (result) {
          case DeleteTasksSolutionSheetEnumResult.Success:
            {
              openAlert('success', 'Karta została pomyślnie usunięta.');
              setCanCardBeRemoved(false);
              getCards();
            }
            break;
          case DeleteTasksSolutionSheetEnumResult.SheetDownloadedBySampleAssessmentGroup:
            {
              openAlert('error', 'Nie można usunać karty pobranej przez ZWO.');
              setCanCardBeRemoved(false);
            }
            break;
          case DeleteTasksSolutionSheetEnumResult.SheetDownloadedToEvaluation:
            {
              openAlert('error', 'Nie można usunać karty pobranej do oceny.');
              setCanCardBeRemoved(false);
            }
            break;
          default: {
            openAlert('delete_error');
            setCanCardBeRemoved(false);
          }
        }
      },
      () => {
        openAlert('delete_error');
        setCanCardBeRemoved(false);
      },
    );
  };

  const afreshCardProcessing = () => {
    showLoader(true);
    const filters = getFilterValues();
    setProcessingPromptOpen(false);
    if (itemsSelection.isAll) {
      processAllCards(...(filters as string[])).then(
        (response) => {
          showLoader(false);
          setProcessingSuccessPromptOpen({ value: true, cardsToProcess: response.data });
          getCards();
        },
        () => {
          setProcessingErrorPromptOpen(true);
          showLoader(false);
        },
      );
    } else {
      processCards(itemsSelection.items).then(
        (response) => {
          showLoader(false);
          setProcessingSuccessPromptOpen({ value: true, cardsToProcess: response.data });
          getCards();
        },
        () => {
          setProcessingErrorPromptOpen(true);
          showLoader(false);
        },
      );
    }
  };

  const selectedCount: number = itemsSelection
    ? itemsSelection.isAll
      ? pageInfo?.totalCount
      : itemsSelection.items.length
    : 0;

  const removingCardsPromptOpenHandler = () => {
    if (selectedCount > 500) {
      openAlert('error', 'Maksymalnie możesz usunąć 500 rekordów jednocześnie.');
    } else {
      setRemovingCardsPromptOpen(true);
    }
  };

  const deleteCards = () => {
    const filters = getFilterValues();
    setRemovingCardsPromptOpen(false);
    if (itemsSelection.isAll) {
      removeCardsByFiltres(...(filters as string[])).catch(() => {
        openAlert('error', 'Błąd podczas wysyłania zlecenia');
      });
    } else {
      const selectedCards: ITasksSolutionSheetDto[] = cards
        .filter((card) => itemsSelection.items.includes(card.id))
        .map((card) => ({
          tasksSolutionSheetId: card.id,
          bundleNumber: card.bundleNumber,
          bundleName: card.bundleName,
          bundleSheetCode: card.bundleSheetCode,
          examCommitteeId: card.examCommitteeId,
          examineeSchoolCode: card.examineeSchoolCode,
          examineeIdentity: card.examineeIdentity,
        }));
      removeCards(selectedCards).catch(() => {
        openAlert('error', 'Błąd podczas wysyłania zlecenia');
      });
    }
  };

  const getActionsMenuIconForSelectedRecord = (): JSX.Element => {
    const items: ActionMenuItem[] = [];
    items.push({
      text: 'Ponowne przetwarzanie kart',
      onClick: () => setProcessingPromptOpen(true),
    });
    items.push({
      text: 'Usuń karty zdających',
      onClick: removingCardsPromptOpenHandler,
    });
    return <ActionsMenu menuItems={items} transformOrigin={{ horizontal: 'left', vertical: 'top' }} />;
  };

  const onCardsActionsClick = (id: string) => {
    if (hasAdminUserRoleSolutionSheetReadPermission) {
      setSelectedCardId(id);
      setSolutionCardModalOpen(true);
    }
  };

  const getActionsMenuIcon = (data: ITasksSolutionSheet, rowIndex: number): JSX.Element => {
    const items: ActionMenuItem[] = [];
    if (hasAdminUserRoleSolutionSheetReadPermission) {
      items.push({
        text: 'Dane szczegółowe',
        onClick: () => {
          onCardsActionsClick(data.id);
        },
      });
    }
    items.push({
      text: 'Usuń kartę',
      onClick: () => openRemovingModal(data),
    });
    return <ActionsMenu menuItems={items} rowIndex={rowIndex} />;
  };

  useEffect(() => {
    const cardsTableData: CardsTableItem[] = cards.map((data: ITasksSolutionSheet, index) => ({
      id: data.id,
      tableEnterId: data.id,
      tasksSolutionSheetId: data.id,
      bundleNumber: data.bundleNumber,
      bundleName: data.bundleName,
      bundleSheetCode: data.bundleSheetCode,
      examineeId: data.examineeId,
      examCommitteeId: getCommitteeLabel(data.examCommitteeId),
      schoolCode: data.examineeSchoolCode,
      examineeIdentity: data.examineeIdentity,
      examineePesel: data.examineePesel,
      examineeIdentityCardNo: data.examineeIdentityCardNo,
      bundleImportDate: formatDate(new Date(data.bundleImportDate)),
      processingDate: data.processingDate ? formatDate(new Date(data.processingDate)) : <></>,
      status: (
        <DotWithLabel
          color={TasksSolutionSheetStatusDetail(data.tasksSolutionSheetStatusId)?.color}
          label={TasksSolutionSheetStatusDetail(data.tasksSolutionSheetStatusId)?.label}
        />
      ),
      actions: getActionsMenuIcon(data, index),
    }));
    setCardsData(cardsTableData);
  }, [cards]);

  const statuses = Object.values(TasksSolutionSheetStatusId).filter((v) => !isNaN(Number(v)));

  const getStatusItems = () => {
    const result = statuses.map((value) => {
      return {
        text: TasksSolutionSheetStatusDetail(value as number).label,
        jsxElement: (
          <CardStatusIcon
            className={classes.cardStatusIcon}
            style={{ color: TasksSolutionSheetStatusDetail(value as number).color }}
          />
        ),
      };
    });
    return result;
  };

  const { columns } = useCardsTableColumns();

  const filterElements: { [key: string]: JSX.Element } = {
    examCommitteeId: (
      <ItemsFilter
        valueName="examCommitteeId"
        valueLabel="Komisja"
        onChange={handleFilterChange}
        resetFilter={!filter.examCommitteeId.length}
        itemsWithValues={convertToFilterItems()}
        filterState={examCommitteeFilter}
        filter={filter.examCommitteeId}
      />
    ),
    bundleImportDate: (
      <DateFilter
        fromValueName="bundleImportFrom"
        toValueName="bundleImportTo"
        onChange={handleFilterChange}
        resetFilter={!filter.bundleImportFrom.length && !filter.bundleImportTo.length}
        isActiveFilter={filter.bundleImportFrom.length > 0 || filter.bundleImportTo.length > 0}
        valueFrom={filter.bundleImportFrom as string}
        valueTo={filter.bundleImportTo as string}
      />
    ),
    processingDate: (
      <DateFilter
        fromValueName="processingDateFrom"
        toValueName="processingDateTo"
        onChange={handleFilterChange}
        resetFilter={!filter.processingDateFrom.length && !filter.processingDateTo.length}
        isActiveFilter={filter.processingDateFrom.length > 0 || filter.processingDateTo.length > 0}
        valueFrom={filter.processingDateFrom as string}
        valueTo={filter.processingDateTo as string}
      />
    ),
    status: (
      <ItemsFilter
        valueName="status"
        valueLabel="status"
        onChange={handleFilterChange}
        resetFilter={filter.status === ''}
        itemsWithImages={getStatusItems()}
        filterState={tasksSolutionSheetStatusId}
        transformHorizontal={250}
        filter={filter.status}
      />
    ),
  };

  const getReprocessingCardsSuccessSubtext = (number: number): string => {
    return `W ramach zlecenia ponownie przetworzona zostanie następująca liczba kart: ${number}`;
  };

  const exportSolutionSheets = () => {
    if (abortController && abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const filters = Object.keys(filter).map((key) => {
      if (Array.isArray(filter[key])) {
        return (filter[key] as string[]).join(',');
      }
      return filter[key];
    });
    showLoader(true, 'Eksportuję dane');
    exportSolutionSheetsApi(signal ?? undefined, sortByColumnId, isDescending, ...(filters as string[]))
      .then(
        (response: Blob) => {
          exportFile(response, 'karty_rozwiazan');
        },
        () => {
          openAlert('error', 'Eksport danych nie powiódł się');
        },
      )
      .finally(() => showLoader(false));
  };

  return (
    <Layout viewType={'admin'}>
      <div className={classes.tableAndBreadcrumContainer}>
        <div className={classes.adminBreadcrumbHeader}>
          <Breadcrumb listRoute={Paths.cards} currentList={t('global:sidebar.cards')} />
          <div className={classes.adminButtonsContainer}>
            <OutlinedButton
              className={classes.exportButton}
              startIcon={<SaveAltIcon className={classes.exportButtonIcon} />}
              onClick={exportSolutionSheets}
            >
              Eksportuj
            </OutlinedButton>
          </div>
        </div>
        <div className={classes.tableWhiteCardFlex}>
          <div className={classes.filtersContainerFlex}>
            <div className={classes.usersHeaderContainer}>
              <Typography variant={'h1'} className={classes.gridHeader}>
                {t('cards:header.title')}
              </Typography>
              {itemsSelection.items.length > 0 && (
                <div
                  style={{
                    display: 'inline-flex',
                    marginBottom: '20px',
                    minWidth: '180px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <SelectedRecordCountDisplay selection={itemsSelection} totalItems={pageInfo?.totalCount}>
                    {hasAdminProcessingOrAdminOkeProcessingPermission && (
                      <div style={{ display: 'flex' }}>
                        <img src={Pipe} className={classes.pipe} alt="ikona pionowa linia" />{' '}
                        {getActionsMenuIconForSelectedRecord()}
                      </div>
                    )}
                  </SelectedRecordCountDisplay>
                </div>
              )}
            </div>
            <Pagination className={classes.adminPaginationFlex} pageInfo={pageInfo} getPage={getPages} />
          </div>
          <div
            className={[
              classes.adminTableContainerFlex,
              isSidebarMinimized ? classes.adminTableContainerFullWidth : classes.adminTableContainerNarrowed,
            ].join(' ')}
          >
            <SelectableTable<CardsTableItem, CardsSortBy>
              columns={columns}
              rows={cardsData}
              onFilterChange={handleFilterChange}
              filter={filter}
              filterElements={filterElements}
              isMultiChoice={true}
              closeFilterItem={uncheckFilterItem}
              uncheckAllFilters={uncheckAllFilters}
              filterbar={filterState}
              sortByProperty={sortByColumnId}
              isDescending={isDescending}
              setIsDescending={setIsDescending}
              setSortByColumn={setSortByColumnId}
              onSelectionChanged={setItemsSelection}
              withHighFilterRow={true}
              onEnterMethod={onCardsActionsClick}
              caption={t('global:sidebar.cards')}
              setForceDeselectAllItems={setForceDeselectAllItems}
              forceDeselectAllItems={forceDeselectAllItems}
            />
          </div>
        </div>
      </div>
      {canCardBeRemoved && (
        <Prompt
          type={'confirmation'}
          open={true}
          size="sm"
          mainActionButtonText={'TAK'}
          onCancel={() => setCanCardBeRemoved(false)}
          onConfirm={deleteCard}
          mainText={`Czy na pewno chcesz usunąć kartę: ${activeCardId}`}
        />
      )}
      {processingPromptOpen && (
        <Prompt
          type={'confirmation'}
          open={true}
          size="sm"
          mainActionButtonText={'TAK'}
          onCancel={() => setProcessingPromptOpen(false)}
          onConfirm={afreshCardProcessing}
          mainText={`Potwierdzenie zlecenia ponownego przetwarzania kart zostanie wprowadzone dla kart ze statusem: `}
          subTexts={[
            {
              text: 'Błąd pobierania, Brak arkusza, Brak zdającego oraz Duplikat',
            },
          ]}
        />
      )}
      {removingCardsPromptOpen && (
        <Prompt
          type={'confirmation'}
          open={true}
          size="sm"
          mainActionButtonText={'TAK'}
          onCancel={() => setRemovingCardsPromptOpen(false)}
          onConfirm={deleteCards}
          mainText={`Czy napewno chcesz usunąć zaznaczone karty?`}
          subTexts={[
            {
              text: 'Usunięte zostaną tylko te karty, które nie zostały pobrane do oceny.',
            },
          ]}
        />
      )}
      {processingSuccessPromptOpen.value && (
        <Prompt
          type={'success'}
          open={true}
          size="sm"
          mainActionButtonText={'POWRÓT'}
          onConfirm={() => setProcessingSuccessPromptOpen({ value: false, cardsToProcess: 0 })}
          mainText={`Zlecenie ponownego przetworzenia kart zostało przyjęte`}
          subTexts={[
            {
              text: getReprocessingCardsSuccessSubtext(processingSuccessPromptOpen.cardsToProcess),
            },
          ]}
        />
      )}
      {processingErrorPromptOpen && (
        <Prompt
          type={'error'}
          open={true}
          size="sm"
          mainActionButtonText={'OK'}
          onConfirm={() => setProcessingErrorPromptOpen(false)}
          mainText={`Wystąpił błąd i zlecenie ponownego przetwarzania kart nie może zostać zrealizowane`}
        />
      )}
      {solutionCardModalOpen && (
        <SolutionCardModal cardId={selectedCardId} onClose={() => setSolutionCardModalOpen(false)} />
      )}
    </Layout>
  );
};

export default Cards;
